import Spinner from 'src/javascripts/components/utilities/Spinner';
import {filterTypeahead} from 'src/javascripts/components/typeaheads/TypeaheadBloodhounds';
import {noResultsTemplate, genericDisplayTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';
import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

export default class AccountsMembershipsDashboardsIndex {

  constructor() {}

  render() {
    let accountUrl = $('body').attr('data-account-url');
    let membershipId = $('.default-typeahead').attr('data-membership-id');

    // On selection - multiple potential actions to take
    $('#dashboard_id').bind('typeahead:select typeahead:autocomplete', function(ev, suggestion) {
      ev.preventDefault();
      let dashboardId = suggestion.record_id;
      let url = '/' + accountUrl + '/dashboards/' + dashboardId + '/accesses';
      let params = {};
      params['membership_id'] = membershipId;
      $.ajax({
        type: 'POST',
        dataType: 'application/json',
        url: url + '?' + $.param(params),
        complete(result) { 
          let url = '/' + accountUrl + '/memberships/' + membershipId + '/dashboards';
          Turbo.visit(url);
        }
      });
    })


  }
}
